const initGiftCardProduct = (root) => {
  if (!(root instanceof HTMLElement) || root.dataset.giftCardReady === 'true') return;

  const variants = [...root.querySelectorAll('[data-gift-card-variant]')];
  const price = root.querySelector('[data-gift-card-price]');
  const submit = root.querySelector('[data-gift-card-submit]');

  const updateSelection = (variant) => {
    if (!(variant instanceof HTMLInputElement)) return;

    const formattedPrice = variant.dataset.giftCardPrice || '';
    const available = variant.dataset.giftCardAvailable === 'true';

    if (price) price.textContent = formattedPrice;

    if (submit instanceof HTMLButtonElement) {
      submit.disabled = !available;
      submit.setAttribute(
        'aria-label',
        available
          ? `Add ${formattedPrice} gift card to bag`
          : `${formattedPrice} gift card is sold out`,
      );
    }
  };

  variants.forEach((variant) => {
    variant.addEventListener('change', () => {
      if (!(variant instanceof HTMLInputElement) || !variant.checked) return;
      updateSelection(variant);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.value);
      window.history.replaceState(window.history.state, '', url);
    });
  });

  const restoreSelection = () => {
    if (!root.isConnected) return;
    const variantId = new URL(window.location.href).searchParams.get('variant');
    const linkedVariant = variants.find(
      (variant) => variant instanceof HTMLInputElement && variant.value === variantId,
    );
    if (linkedVariant) linkedVariant.checked = true;
    updateSelection(variants.find(
      (variant) => variant instanceof HTMLInputElement && variant.checked,
    ));
  };

  restoreSelection();
  window.addEventListener('pageshow', restoreSelection);
  window.addEventListener('popstate', restoreSelection);
  root.dataset.giftCardReady = 'true';
};

document.querySelectorAll('[data-gift-card-product]').forEach(initGiftCardProduct);

document.addEventListener('shopify:section:load', (event) => {
  if (!(event.target instanceof Element)) return;

  if (event.target.matches('[data-gift-card-product]')) {
    initGiftCardProduct(event.target);
  }

  event.target.querySelectorAll('[data-gift-card-product]').forEach(initGiftCardProduct);
});
